<template>
  <div
    ref="iconRef"
    class="widget-help-icon-tooltip"
    @mouseenter="showTooltip"
    @mouseleave="hideTooltip"
  >
    <widget-icon
      :name="icon as WidgetIconName"
      :size="iconSize"
      :class="iconClass"
    />

    <widget-tooltip
      :visible="tooltipVisible"
      :text="tooltip"
      :target="iconRef"
      :position="position"
      variant="info"
    />
  </div>
</template>

<script setup lang="ts">
import WidgetIcon from '@widgets/shared/components/WidgetIcon.vue'
import WidgetTooltip from '@widgets/shared/components/WidgetTooltip.vue'
import type { WidgetIconName } from '@widgets/shared/icons/icons'
import { ref, useTemplateRef } from '@/composition/vue/compositionApi'

withDefaults(
  defineProps<{
    tooltip: string
    icon?: string
    iconSize?: string
    iconClass?: string | string[] | Record<string, boolean>
    position?: 'top' | 'bottom' | 'left' | 'right'
  }>(),
  {
    icon: 'tmi-help',
    iconSize: '14px',
    position: 'top',
  },
)

const iconRef = useTemplateRef<HTMLElement>('iconRef')
const tooltipVisible = ref(false)

const showTooltip = () => {
  tooltipVisible.value = true
}

const hideTooltip = () => {
  tooltipVisible.value = false
}
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables.scss';

.widget-help-icon-tooltip {
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
  color: $error;
}
</style>
